import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { cn } from './_cn';
import { SkeletonBlock } from '../skeleton/skeleton';

const StatCard = ({
  icon: Icon,
  label,
  value,
  hint,
  tone = 'slate',
  loading = false,
  onClick,
  trend,
  style,
  className = '',
  valueClassName = '',
  tooltip,
  tooltipId = 'stat-card-tooltip',
  uppercaseLabel = true,
}) => {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      style={style}
      className={cn(
        'reveal group relative min-w-0 overflow-hidden rounded-md border border-slate-200 bg-white p-4 shadow-sm transition dark:border-slate-700 dark:bg-slate-800/70 sm:p-5',
        onClick
          ? 'w-full text-left hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-md dark:hover:border-slate-600'
          : '',
        className,
      )}
    >
      <div className="flex items-baseline gap-1">
        {loading ? (
          <SkeletonBlock className="h-8 w-32" />
        ) : (
          <span
            className={cn(
              'break-words tabular-nums text-2xl font-bold tracking-tight sm:text-3xl',
              valueClassName || 'text-slate-900 dark:text-slate-100',
            )}
          >
            {value}
          </span>
        )}
      </div>
      {label ? (
        <p
          className={cn(
            'mt-2 flex items-center gap-1 text-sm font-medium text-slate-500 dark:text-slate-400',
            uppercaseLabel && 'uppercase',
          )}
        >
          <span>{label}</span>
          {tooltip ? (
            <button
              type="button"
              aria-label={`About ${label}`}
              data-tooltip-id={tooltipId}
              data-tooltip-content={tooltip}
              onClick={(e) => e.stopPropagation()}
              className="inline-flex items-center justify-center rounded-full text-slate-500 transition hover:text-blue-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-200 dark:text-slate-400 dark:hover:text-sky-400 dark:focus-visible:ring-sky-500/40"
            >
              <InformationCircleIcon strokeWidth={2} className="h-4 w-4" />
            </button>
          ) : null}
        </p>
      ) : null}
      {!loading && (hint || trend) ? (
        <div className="mt-2 flex items-center gap-2 text-xs">
          {trend ? (
            <span
              className={cn(
                'font-semibold',
                trend.positive
                  ? 'text-emerald-600 dark:text-emerald-400'
                  : 'text-rose-600 dark:text-rose-400',
              )}
            >
              {trend.label}
            </span>
          ) : null}
          {hint ? (
            <span className="text-slate-500 dark:text-slate-400">{hint}</span>
          ) : null}
        </div>
      ) : null}
    </Tag>
  );
};

export default StatCard;
